import React, { Fragment } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { loadMostClickedShowsByTopic } from '../../../api/topic/load-most-clicked-shows-by-topic';
import { Swimlane } from '../../../components/Swimlane/Swimlane';
import { SwimlaneTitle } from '../../../components/Swimlane/SwimlaneTitle';
import { Swipeable } from '../../../components/Swipeable/Swipeable';
import { ShowTeaser } from '../../../components/Teaser/ShowTeaser/ShowTeaser';
import { queryKeys } from '../../../config/use-query';
import { useAxios } from '../../../hooks/use-axios';
import { useShowPosterImage } from '../../../hooks/use-show-poster-image';
import { useValidTopic } from '../../../hooks/use-valid-topic';
import { useShowDetails } from '../use-show-details';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TrendingShowsSwimlane = () => {
  const axios = useAxios();
  const {
    t
  } = useTranslation();
  const {
    show: showDetail,
    error: errorShowDetail
  } = useShowDetails();
  const validTopic = useValidTopic(showDetail?.topicUrns.map(urn => ({
    urn
  })) ?? []);
  const {
    data: shows,
    error: errorMostClickedShows
  } = useQuery({
    queryKey: [queryKeys.MostClickedShowsByTopic(validTopic?.id ?? ''), axios],
    queryFn: () => loadMostClickedShowsByTopic(axios, validTopic?.id ?? ''),
    enabled: !!validTopic
  });
  const filteredShows = shows?.filter(show => show.id !== showDetail?.id);
  const {
    showPosterImage,
    aspectRatio
  } = useShowPosterImage(filteredShows);
  const showSwimlane = filteredShows?.length !== 0 && !errorShowDetail && !errorMostClickedShows;
  return /*#__PURE__*/_jsx(Fragment, {
    children: showSwimlane && /*#__PURE__*/_jsxs(Swimlane, {
      children: [/*#__PURE__*/_jsx(SwimlaneTitle, {
        title: t('global.moreShows')
      }), /*#__PURE__*/_jsx(Swipeable, {
        placeholderAspectRatio: aspectRatio,
        children: filteredShows?.map((show, index) => /*#__PURE__*/_jsx(ShowTeaser, {
          show: show,
          index: index,
          showPosterImage: showPosterImage
        }, show.id))
      })]
    })
  });
};